import * as React from "react";
import styleable from "react-styleable";

import Nav from "../components/mainlayout/nav"
import * as styles from "../../css/pages/mainlayout.css"
import globalStore from "../stores/GlobalStore"
import * as AccountActions from "../actions/AccountActions"
import NotificationBox from "../components/mainlayout/NotificationBox"

import { t } from 'ttag';

/**
 * MainLayout component.
 * ## styleable
 * * **nav** Add styling to the (_webctopbar_ of) the navigation bar.
 * * **contentBox** Add styling to the content box.
 *
 * ## CSS styling
 * * **.wcrc-button** override styling of the button (also affects styling of buttons in components/mainlayout/PortalButton)
 * * **.wcrc-textinput** override styling of the text input (also affects styling of text input in components/mainlayout/PortalInput)
 * * **.wcrc-ml-loginwindow** override styling of the login window
 *
 * ## Other
 * * The background image for the login page is retrieved from ** /cdn/images/background.jpg **.
 *
 */
class MainLayout extends React.Component<any, any> {

    constructor() {
        super(undefined); // TODO: undefined
        this.state = {
            email: '',
            password: '',
            globalUserId: globalStore.getAccountId(),
            globalAuthStr: globalStore.getAccountAuthString(),
            locale: ''
        };
    }

    signIn() {
        AccountActions.signIn(this.state.email, this.state.password, this.props.onSignIn);
    }

    changeEmail(e) {
        this.setState({"email": e.target.value})
    }

    changePassword(e) {
        this.setState({"password": e.target.value})
    }

    componentWillMount(){
        globalStore.on("change", () => {
            this.setState({
                globalUserId: globalStore.getAccountId(),
                globalAuthStr: globalStore.getAccountAuthString(),
                locale: globalStore.getLocale()
            });
        })

        // Check session login
        AccountActions.sessionSignIn(this.props.onSignIn);
    }

    componentWillUnmount(){
        globalStore.removeAllListeners("change");
    }

    render() {

        const {location} = this.props;
        const {headerprops} = this.props.route;

        (window as any).reactLocation =  location;

        // Show login form?
        if(this.state.globalUserId == null){
            // Yes
            return (
                <div className = {this.props.css.webcmainlayout + " webcloginlayout " + this.props.css.webcloginlayout}>
                    <NotificationBox/>
                    <Nav languages={this.props.languages} location={location} title={headerprops.title} subtitle={headerprops.subtitle} image={headerprops.image} css={{compose:{webctopbar: this.props.css.nav}}} languageChoiceCss={this.props.languageChoiceCss} i18n={this.props.i18n} />
                    <div
                        className = {"container-fluid " + this.props.css.contentBox}>
                        <div className = "row">
                            <div className = "col-xs-3"></div>
                            <div className = {"col-xs-6 wcrc-ml-loginwindow " + this.props.css.webcloginlayout_group}>
                                <div>
                                    {this.props.loginChildren}
                                    <h1>{t`Login`}</h1> {this.state.globalUserId} {this.state.globalAuthStr}
                                    <input type="email" className = "wcrc-textinput" placeholder={t`E-mail`} onChange={this.changeEmail.bind(this)}
                                           value={this.state.email}/>
                                    <input type="password" className="wcrc-textinput" placeholder={t`Wachtwoord`}
                                           onChange={this.changePassword.bind(this)} value={this.state.password}
                                           onKeyPress={(e) => {if (e.key === 'Enter') {
                                               this.signIn()
                                           }}}/>
                                    <input onClick={this.signIn.bind(this)} className = "wcrc-button" type="submit" value={t`Aanmelden`}/>
                                </div>
                            </div>
                            <div className = "col-xs-3"></div>
                        </div>
                    </div>
                </div>

            );
        }else{
            // No
            let leftMenu, topMenu;
            let showLeftMenu = false; // For compatibility with older versions where only a left menu was present
            if(this.props.route.menu){// For compatibility with older versions where only a left menu was present
                leftMenu =  <div className = {this.props.css.webcleftmenu}>
                                {this.props.route.menu}
                            </div>;
                showLeftMenu = true;
            }else if(this.props.route.leftMenu){
                leftMenu =  <div className = {this.props.css.webcleftmenu}>
                                {this.props.route.leftMenu}
                            </div>;
                showLeftMenu = true;
            }
            if(this.props.route.topMenu){
                topMenu = this.props.route.topMenu
            }

            return (
                <div className = {this.props.css.contentBoxOuter}>
                    <NotificationBox/>
                    <Nav languages={this.props.languages} location={location} title={headerprops.title} subtitle={headerprops.subtitle} image={headerprops.image} css={{compose:{webctopbar: this.props.css.nav}}} languageChoiceCss={this.props.languageChoiceCss} i18n={this.props.i18n} />

                    {topMenu}
                    {leftMenu}

                    <div className = {this.props.css.contentBox + " " + this.props.css.contentBox + " " + (showLeftMenu ? this.props.css.room_for_left_menu : "")}>
                        {this.props.children}
                    </div>
                </div>

            );
        }
    }
}
export default styleable(styles)(MainLayout)